export default {
  /**
   * Gets the email automation lists for the current company
   * @param state
   * @returns {Array}
   */
  contactsList(state) {
    return state.emailAutomationLists;
  },
};
